import MemberRequest from "./MemberRequest";
import AppConfig from "./AppConfig";

function getResult(data) {
  let res=false;
  if (data.hasOwnProperty("result")) {
    if (data.result ===  "yes") {
      res=data;
    }
  }
  return res;
}

const sendFileApi = async function (file,fileId,pageAlerts,onUploadProgress) {
  let res=false;
  let req=new MemberRequest();
  req._pageAlerts=pageAlerts;
  req._onUploadProgress= function(progressEvent){onUploadProgress(progressEvent,fileId);};
  req.addFiles("imageType",file);
  req._url=AppConfig.base_url+"/membership/upload";
  res = await req.send(getResult,0,false);
  return res;
};

export default async function memberFileUploadApi(file,fileId,pageAlerts,onUploadProgress) {
  return await sendFileApi(file,fileId,pageAlerts,onUploadProgress);
}
